import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProductsService } from '../../../shared/services/products.service';

@Component({
  selector: 'app-product-overview',
  templateUrl: './product-overview.component.html',
  styleUrls: ['./product-overview.component.scss'],
  standalone: false,
})
export class ProductOverviewComponent {
  constructor(
    private router: Router,
    private productsService: ProductsService,
  ) {}

  isActive(route: string): boolean {
    return this.router.url.includes(route);
  }

  onDetailsTabClick(): void {
    // Clear selected models only when returning to the details tab
    this.productsService.clearSelectedCheckboxes();
    this.productsService.setFilteredSelectedRows([]);
  }
}
